import { render, staticRenderFns } from "./holidaysForm.vue?vue&type=template&id=11efef16&scoped=true&"
import script from "./holidaysForm.vue?vue&type=script&lang=js&"
export * from "./holidaysForm.vue?vue&type=script&lang=js&"
import style0 from "./holidaysForm.vue?vue&type=style&index=0&id=11efef16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11efef16",
  null
  
)

export default component.exports